import React from 'react';
import Fade from '@material-ui/core/Fade';
import Base, { CopyContainer, FADE_TIMEOUT, H2, Icon, ImgContainer, P, Root } from '../Base';

class BizarreTerms extends Base {
  static isVisible = () => true;

  icon = '/images/insurance_tutorial/05_bizarre_terms.svg';

  render = () => {
    return (
      <Fade in timeout={FADE_TIMEOUT}>
        <Root>
          <ImgContainer>
            <Icon src={this.icon} />
          </ImgContainer>

          <CopyContainer>
            <H2>Now, for the bizarre terms</H2>

            <P>Let's talk about deductibles, copays, co-insurance and your out-of-pocket max.</P>

            <P>We'll explain how these terms apply to your plan next.</P>
          </CopyContainer>
        </Root>
      </Fade>
    );
  };
}

export default BizarreTerms;
